import { useTheme } from '@mui/material/styles';
import { useAtomValue } from "jotai";
import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useSwitchTeam from "../../components/app/hooks/useSwitchTeam";
import { teamsAtom } from "../../stores/jotai/teams/teams";
import { getTabFromQuery } from "../../util/tab_query";
import TeamDashboardView from "./team";

interface Props {
    cohort?: CohortState;
    team?: TeamState;
    location: any;
}

const DEFAULT_PATH = "cohort_stats";

export const DashboardView: FC<Props> = (props) => {
    const [currentView, setCurrentView] = useState<string>(DEFAULT_PATH);
    const theme = useTheme();
    const [lastQuerySetFeature, setLastQuerySetFeature] =
        useState<string>(DEFAULT_PATH);
    const { switchTeam } = useSwitchTeam();
    const location = useLocation()
    const teams=useAtomValue(teamsAtom);

    const handleChangeDisplay = (target) => {
        setCurrentView(target);
    };

    const handleQueryCheck = () => {
        const possibleFeature = getTabFromQuery({...props, location}, [
            "cohort_stats",
            "dash",
            "prof_stats",
            "wiki_seen",
        ]);

        if (!!possibleFeature) {
            setLastQuerySetFeature(possibleFeature);
        } else {
            setLastQuerySetFeature(DEFAULT_PATH);
        }
    };

    useEffect(() => {
        handleQueryCheck();
    }, [lastQuerySetFeature, location]);

    useEffect(() => {
        handleChangeDisplay(lastQuerySetFeature);
    }, [lastQuerySetFeature]);

    return (
        <TeamDashboardView
            onViewChange={handleChangeDisplay}
            targetView={currentView}
            switchTeam={switchTeam}
            {...props}
            theme={theme}
            teams={teams}
        />
    );
};
